import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { screen } from 'legacy/styles/screen'

export const FooterContainer = styled.div`
  position: relative;

  display: flex;
  flex-flow: column;
  width: 100%;
  margin-top: 32px;
  z-index: 1;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;

  ${screen.md} {
    flex-flow: row;
    align-items: center;
    margin-bottom: 0;
  }
`

export const LoadDetailsPageContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 4px 4px;

  color: ${getToken('color-neutral-darkest')};

  ${screen.md} {
    padding: 0 4px 60px 4px;
  }
`

export const LoadInformationContainer = styled.div`
  display: flex;
  flex-basis: 100%;
  flex-flow: column;
  justify-content: space-between;

  ${screen.md} {
    margin-bottom: 0;
  }

  ${screen.lg} {
    flex-basis: 70%;
    min-height: 600px;
  }
`

export const MainContentContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  align-items: stretch;
  width: 100%;
  height: auto;

  background: ${getToken('color-neutral-white')};
  border: none;

  ${screen.md} {
    flex-flow: row nowrap;
    min-height: 672px;
    margin-top: ${props => (props.hasMarginTop ? '40px' : 'none')};

    border: 2px solid ${getToken('color-neutral-lighter')};
  }
`

// noinspection CssInvalidPropertyValue
export const MapWrapper = styled.div`
  display: none;

  ${screen.lg} {
    display: flex;
    flex-basis: 30%;
    height: auto;
  }
`

export const RelatedLoadsWrapper = styled.div`
  margin-top: 24px;
`

export const BannerWrapper = styled.div`
  & > * {
    margin-bottom: 16px;
  }
`
